import PropTypes from 'prop-types';
import { toClassName } from '../../../utils/toClassName';
import styles from './IconButton.module.css';

export const IconButton = ({
  onClick,
  icon: Icon,
  title,
  isFilled,
  color,
  altColor,
  style,
  disabled,
  loading,
}) => {
  const containerClass = toClassName(
    styles.container,
    disabled && styles.disabled,
  );
  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className={containerClass}
      style={{
        ...style,
        ...{
          backgroundColor: isFilled ? color : altColor,
          borderColor: color,
        },
      }}>
      {!loading ? (
        <>
          <Icon
            className={styles.icon}
            style={{ color: !isFilled ? color : altColor }}
          />
          <p
            className={styles.title}
            style={{ color: !isFilled ? color : altColor }}>
            {title}
          </p>
        </>
      ) : (
        <span className="icon fa-2x" style={{ color: altColor }}>
          <i className="fa fa-circle-o-notch fa-spin" />
        </span>
      )}
    </button>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isFilled: PropTypes.bool,
  color: PropTypes.string,
  altColor: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};
IconButton.defaultProps = {
  isFilled: false,
  color: '#595478',
  altColor: '#FFFFFF',
  disabled: false,
  loading: false,
};
